import { Injectable } from '@angular/core';
import { MAP_SETUP_PATH } from './install/shared/navigation/constants';
import { Router, ActivatedRouteSnapshot, CanActivate } from '@angular/router';

@Injectable()
export class AppDefaultGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    this.router.navigate([MAP_SETUP_PATH], { queryParams: route.queryParams });
    return true;
  }

}
